/**
 * Usage:
 *
 * var grid = new Grid(); // should be used with a storage container
 * if('xs' === grid.bp() || 'sm' === grid.bp()) {
 *   // gets executed when the active size is breakpoint xs or sm
 * }
 *
 * XS is everything that is in XS -> it doesn't distinguishes between xs-fluid and xs-fixed
 *
 * @param config
 * @constructor
 */
function Grid(config) {
  this.config = jQuery.extend({
    // defaults.

    // sizes in px, only at xs is auto allowed, when auto for xs the size of sm is used
    xs_max_size: 'auto',
    sm_min_size: '768',
    md_min_size: '992',
    lg_min_size: '1200',
    xl_min_size: '1900',
  }, config);
}

Grid.prototype = {
  /**
   * Breakpoint function to determine the active breakpoint
   * doesn't use JS's matchMedia for better browser support
   *
   * @returns {string}
   */
  bp: function () {
    var width = window.innerWidth;

    if (('auto' === this.config.xs_max_size && width <= (this.config.sm_min_size - 1)) || ('auto' !== this.config.xs_max_size && width <= this.config.xs_max_size)) {
      return 'xs';
    } else if (width >= this.config.sm_min_size && width <= (this.config.md_min_size - 1)) {
      return 'sm';
    } else if (width >= this.config.md_min_size && width <= (this.config.lg_min_size - 1)) {
      return 'md';
    } else if (width >= this.config.lg_min_size && width <= (this.config.xl_min_size - 1)) {
      return 'lg';
    } else if (width >= this.config.xl_min_size) {
      return 'xl';
    } else {
      return '';
    }
  },
  /**
   *
   * @param {Array} bp
   */
  isBp: function (bp) {
    if (-1 !== bp.indexOf(this.bp())) {
      return true;
    } else {
      return false;
    }
  }
};
